import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { AccessControl } from "@components";
import styles from "../styles/MainSidebar.module.css";

const SubMenu = (props) => {
  const [subNavState, showSubNavState] = useState(false);
  const {
    targetRoles,
    title,
    icon,
    path,
    subNav,
    showTitle,
    isActive,
    onAfterClick,
    onClick,
  } = props;
  const navigate = useNavigate();

  const iconClose = <i className="bi bi-caret-down-fill"></i>;
  const iconOpen = <i className="bi bi-caret-up-fill"></i>;

  const handleClickLink = (e) => {
    e.preventDefault();
    if (!path) {
      onClick();
      return;
    }
    if (subNav?.length) {
      showSubNavState(!subNavState);
    } else {
      navigate(path);
      onAfterClick();
    }
  };

  return (
    <AccessControl targetRoles={targetRoles}>
      <div
        className={clsx({
          [styles.subnavActive]: isActive || (subNavState && subNav?.length),
        })}
      >
        <Link
          to={path}
          style={{ textDecoration: "none" }}
          className={`row m-0 pr-0 pl-0 flex-nowrap ${styles.sidebarItem}`}
          onClick={handleClickLink}
        >
          <div
            className="h5 m-0"
            style={{ width: "60px", display: "flex", justifyContent: "center" }}
          >
            {icon}
          </div>
          {showTitle && (
            <>
              <div className="col text-truncate p-0">{title}</div>
              <div className="col-2" style={{ fontSize: "0.8em" }}>
                {subNav?.length && subNavState
                  ? iconOpen
                  : subNav?.length
                  ? iconClose
                  : null}
              </div>
            </>
          )}
        </Link>
        {subNavState &&
          showTitle &&
          subNav.map((item, index) => {
            return (
              <Link
                key={item.path + index}
                to={item.path}
                className={`row m-0 ${styles.subnavItem}`}
                onClick={() => {
                  onAfterClick();
                  showSubNavState(false);
                }}
              >
                <div className="h5 m-0" style={{ width: "60px" }}>
                  {item.icon}
                </div>
                <div className="col text-truncate p-0">{item.title}</div>
              </Link>
            );
          })}
      </div>
    </AccessControl>
  );
};

/* required: display name */
SubMenu.displayName = "SubMenu";

/* required: props types */
SubMenu.propTypes = {
  targetRoles: PropTypes.array,
  title: PropTypes.string,
  icon: PropTypes.element,
  path: PropTypes.string,
  subNav: PropTypes.array,
  showTitle: PropTypes.bool,
  isActive: PropTypes.bool,
  onAfterClick: PropTypes.func,
};

/* required: default props */
SubMenu.defaultProps = {
  targetRoles: [],
  title: "",
  icon: null,
  path: "",
  subNav: [],
  showTitle: true,
  isActive: false,
  onAfterClick: () => {},
};

export { SubMenu };
